exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  font-size: 8px;\n  color: white;\n  text-align: center;\n  background: black;\n  float: right; }\n\n.notif {\n  position: relative;\n  display: block;\n  height: 50px;\n  width: 100px;\n  text-decoration: none; }\n\n.num {\n  position: absolute;\n  right: 0px;\n  top: -6px;\n  color: black;\n  /* background-color: red; */\n  /*  color: #e91313; */ }\n\n.mat-menu-panel.myStyle {\n  max-width: 500px !important;\n  width: 500px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/report/notification/notification.component.scss
// module id = ../../../../../src/app/report/notification/notification.component.scss
// module chunks = main